var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.10033 0.0996094C1.45394 0.0996094 0.101562 1.37103 0.101562 2.91887V25.9824C0.101634 26.1222 0.141453 26.2594 0.216897 26.3799C0.29234 26.5004 0.400667 26.5997 0.530659 26.6676C0.660652 26.7355 0.807585 26.7695 0.956247 26.766C1.10491 26.7626 1.24989 26.7219 1.37619 26.6481L10.1016 21.5595L18.8269 26.6481C18.9532 26.7219 19.0982 26.7626 19.2469 26.766C19.3955 26.7695 19.5425 26.7355 19.6725 26.6676C19.8025 26.5997 19.9108 26.5004 19.9862 26.3799C20.0617 26.2594 20.1015 26.1222 20.1016 25.9824V2.91887C20.1016 1.37103 18.7492 0.0996094 17.1028 0.0996094H3.10033ZM3.10033 1.66844H17.1028C17.8545 1.66844 18.4328 2.21215 18.4328 2.91887V24.5756L10.5388 19.9733C10.4073 19.8973 10.2559 19.857 10.1016 19.857C9.94719 19.857 9.79585 19.8973 9.66437 19.9733L1.77028 24.5756V2.91887C1.77028 2.21215 2.34862 1.66844 3.10033 1.66844Z",
    fill: "#767676",
    stroke: "#767676",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.3536ebfc963b067aa8c29457c84bdab5.svg";
export { ForwardRef as ReactComponent };